<template>
  <div>
    <div class="cake-layout">
      <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </div>
</template>
<script>
import routeMap from '@/router/routes/cakeMap.js'
import Axios from 'axios'
// import layoutTabbar from '@/components/Tabbar.vue'

export default {
  name: 'Cake',
  components: {
    // layoutTabbar
  },
  data() {
    return {
    }
  },
}
</script>
<style lang="scss" scoped>
  .cake-layout{
    // padding-bottom: 1rem;
    background: $cake-primary-bg;
    min-height: calc(100vh - 1rem);
  }
</style>